import React from 'react';
import { motion } from 'framer-motion';

const LineLoader: React.FC<{ message?: string }> = ({ message }) => {
  return (
    <div className="absolute top-0 left-0 right-0 z-50 flex flex-col items-center">
      <div className="relative w-full h-1.5 bg-teal-500/10 overflow-hidden">
        <motion.div
          className="absolute top-0 left-0 h-full bg-gradient-to-r from-teal-400 to-cyan-400"
          initial={{ x: '-100%' }}
          animate={{ x: '100%' }}
          transition={{
            duration: 2,
            repeat: Infinity,
            repeatType: 'loop',
            ease: 'linear',
          }}
        />
      </div>
      {message && <p className="mt-2 px-3 py-1 text-sm font-medium text-white bg-black/50 rounded-lg backdrop-blur-sm">{message}</p>}
    </div>
  );
};

export default LineLoader;
